import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrivacyPage = function PrivacyPage() {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("div", {
      className: "page-body md:w-auto; py-8 px-16",
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("strong", {
          children: "Privacy Policy"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: "Effective as of Apr 1 2021"
      }), /*#__PURE__*/_jsxs("p", {
        children: ["This Privacy Policy describes the privacy practices of Subkit Inc. ", /*#__PURE__*/_jsx("strong", {
          children: "(\"Subkit,\""
        }), " \u201C", /*#__PURE__*/_jsx("strong", {
          children: "we,"
        }), "\" \"", /*#__PURE__*/_jsx("strong", {
          children: "us"
        }), "\" or \"", /*#__PURE__*/_jsx("strong", {
          children: "our"
        }), "\") and how we handle personal information that we collect through our digital properties that link to this Privacy Policy, including our website and mobile application (collectively, the \u201C", /*#__PURE__*/_jsx("strong", {
          children: "Service"
        }), "\u201D), as well as through social media, our marketing activities, and other activities described in this Privacy Policy."]
      }), /*#__PURE__*/_jsx("p", {
        children: "Subkit provides certain services (e.g. website hosting and access to Providers service pages) to its business customers.\xA0 This Privacy Policy does not apply to information that we process on behalf of our business customers while providing services to them. Our use of this information is restricted by our agreements with those business customers. If you have concerns regarding personal information that we process on behalf of a business, please direct your concerns to that business. This Privacy Policy covers both Users of the Subkit service, as well as subsequent Providers of services using the Subkit software service."
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("a", {
          href: "https://subkit-term-docs.s3.amazonaws.com/Subkit+User+Privacy+Policy.pdf",
          rel: "noreferrer",
          target: "_blank",
          children: "You can download a printable copy of this Privacy Policy here."
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("strong", {
          children: "Index"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("strong", {
          children: "Personal information we collect"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: "Information you provide to us.\xA0 Personal information you may provide to us through the Service or otherwise includes:"
      }), /*#__PURE__*/_jsx("ul", {
        className: "list-disc my-3 mx-6",
        children: /*#__PURE__*/_jsx("li", {
          children: "Other data not specifically listed here, which we will use as described in this Privacy Policy or as otherwise disclosed at the time of collection."
        })
      }), /*#__PURE__*/_jsx("p", {
        children: "Third-party sources. We may combine personal information we receive from you with personal information we obtain from other sources, such as:"
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsx("li", {
          children: "Public sources, such as public records, social media platforms, and other publicly available sources."
        }), /*#__PURE__*/_jsx("li", {
          children: "Marketing partners, such as joint marketing partners and event co-sponsors."
        })]
      }), /*#__PURE__*/_jsx("p", {
        children: "Automatic data collection.\xA0 We, our service providers, and our business partners may automatically log information about you, your computer or mobile device, and your interaction over time with the Service, our communications and other online services, such as:"
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("strong", {
          children: "How we use your personal information"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: "Service delivery.\xA0 We may use your personal information to:"
      }), /*#__PURE__*/_jsx("p", {
        children: "Research and development.\xA0 We may use your personal information for research and development purposes, including to analyze and improve the Service and our business."
      }), /*#__PURE__*/_jsx("p", {
        id: "1de3706e-8d8b-44d2-b6d7-b6f4630da39d",
        children: "Marketing and advertising.\xA0 We, our service providers and our third-party advertising partners may collect and use your personal information for marketing and advertising purposes:"
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsx("li", {
          children: "Direct marketing. We may send you Subkit-related or other direct marketing communications as permitted by law. You may opt-out of our marketing communications as described in the Opt-out of marketing section below."
        }), /*#__PURE__*/_jsx("li", {
          children: "Interest-based advertising. We may engage third-party advertising companies and social media companies to display ads on our Service and other online services. These companies may use cookies and similar technologies to collect information about your interaction (including the data described in the automatic data collection section above) over time across the Service, our communications and other online services, and use that information to serve online ads that they think will interest you. This is called interest-based advertising. We may also share information about our users with these companies to facilitate interest-based advertising to those or similar users on other online platforms. You can learn more about your choices for limiting interest-based advertising in the Your choices section of our Cookie Notice."
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "71e0dc73-9d68-48cc-8774-0401cca78c10",
        children: "Compliance and protection.\xA0 We may use your personal information to:"
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsx("li", {
          children: "comply with applicable laws, lawful requests, and legal process, such as to respond to subpoenas or requests from government authorities;"
        }), /*#__PURE__*/_jsx("li", {
          children: "protect our, your or others\u2019 rights, privacy, safety or property (including by making and defending legal claims);"
        }), /*#__PURE__*/_jsx("li", {
          children: "audit our internal processes for compliance with legal and contractual requirements and internal policies;"
        }), /*#__PURE__*/_jsx("li", {
          children: "enforce the terms and conditions that govern the Service; and"
        }), /*#__PURE__*/_jsx("li", {
          children: "prevent, identify, investigate and deter fraudulent, harmful, unauthorized, unethical or illegal activity, including cyberattacks and identity theft."
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "6d812c56-0e0f-4f4c-8854-845bc6297547",
        children: "With your consent.\xA0 In some cases, we may specifically ask for your consent to collect, use or share your personal information, such as when required by law."
      }), /*#__PURE__*/_jsx("p", {
        id: "8afd10b4-c2b2-4127-8c69-a538164e45cd",
        children: "To create anonymous, aggregated or de-identified data.\xA0 We may create anonymous, aggregated or de-identified data from your personal information and other individuals whose personal information we collect.\xA0 We make personal information into anonymous, aggregated or de-identified data by removing information that makes the data identifiable to you.\xA0 We may use this anonymous, aggregated or de-identified data and share it with third parties for our lawful business purposes, including to analyze and improve the Service and promote our business."
      }), /*#__PURE__*/_jsx("p", {
        id: "51a962bf-8a54-4210-904d-06260e779dd3",
        children: "Retention. We generally retain personal information to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements, to establish or defend legal claims, or for fraud prevention purposes.\xA0 To determine the appropriate retention period for personal information, we may consider factors such as the amount, nature, and sensitivity of the personal information, the potential risk of harm from unauthorized use or disclosure of your personal information, the purposes for which we process your personal information and whether we can achieve those purposes through other means, and the applicable legal requirements."
      }), /*#__PURE__*/_jsx("p", {
        id: "3b0c57f7-124c-452d-8854-b1b5d3c32251"
      }), /*#__PURE__*/_jsx("p", {
        id: "fd8a4786-b975-44a5-acc1-ed948d2420b3",
        children: /*#__PURE__*/_jsx("strong", {
          children: "How we share your personal information"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "e2b64c77-c145-497d-9514-6f4c6ffe4cb3",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Your choices"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "df26e111-71f0-4343-8f51-a2e8491a2538",
        children: "Access or update your information. If you have registered for an account with us through the Service, you may review and update certain account information by logging into the account."
      }), /*#__PURE__*/_jsx("p", {
        id: "c8f88140-420c-4426-baf6-261ba12b301f",
        children: "Opt-out of marketing communications.\xA0 You may opt-out of marketing-related emails by following the opt-out or unsubscribe instructions at the bottom of the email, or by contacting us.\xA0 Please note that if you choose to opt-out of marketing-related emails, you may continue to receive service-related and other non-marketing emails."
      }), /*#__PURE__*/_jsx("p", {
        id: "8645a05c-3bca-4f64-a977-dc259969fae3",
        children: "Mobile location data.\xA0 You can disable our access to your device\u2019s precise geolocation in your mobile device settings."
      }), /*#__PURE__*/_jsx("p", {
        id: "ce772b8a-a0a0-44fb-a479-5a24c5ac9db4",
        children: "Advertising choices. \xA0 You can limit use of your information for interest-based advertising by:"
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsx("li", {
          children: "Browser settings. Blocking third-party cookies in your browser settings."
        }), /*#__PURE__*/_jsx("li", {
          children: "Privacy browsers/plug-ins. By using privacy browsers or ad-blocking browser plug-ins that let you block tracking technologies."
        }), /*#__PURE__*/_jsxs("li", {
          children: ["Platform settings. Google and Facebook offer opt-out features that let you opt-out of use of your information for interest-based advertising:", /*#__PURE__*/_jsxs("ul", {
            className: "list-disc my-3 mx-6",
            children: [/*#__PURE__*/_jsx("li", {
              children: "Google: https://adssettings.google.com/"
            }), /*#__PURE__*/_jsx("li", {
              children: "Facebook: https://www.facebook.com/about/ads"
            })]
          })]
        }), /*#__PURE__*/_jsxs("li", {
          children: ["Ad industry tools. Opting out of interest-based ads from companies participating in the following industry opt-out programs:", /*#__PURE__*/_jsxs("ul", {
            className: "list-disc my-3 mx-6",
            children: [/*#__PURE__*/_jsx("li", {
              children: "Network Advertising Initiative: http://www.networkadvertising.org/managing/opt_out.asp"
            }), /*#__PURE__*/_jsx("li", {
              children: "Digital Advertising Alliance: optout.aboutads.info."
            }), /*#__PURE__*/_jsx("li", {
              children: "AppChoices mobile app, available at https://www.youradchoices.com/appchoices, which will allow you to opt-out of interest-based ads in mobile apps served by participating members of the Digital Advertising Alliance."
            })]
          })]
        }), /*#__PURE__*/_jsx("li", {
          children: "Mobile settings. Using your mobile device settings to limit use of the advertising ID associated with your mobile device for interest-based advertising purposes."
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "2ad8e80e-3965-488a-8810-8428efd476d3",
        children: "Do Not Track.\xA0 Some Internet browsers may be configured to send \u201CDo Not Track\u201D signals to the online services that you visit.\xA0 We currently do not respond to \u201CDo Not Track\u201D or similar signals.\xA0 To find out more about \u201CDo Not Track,\u201D please visit http://www.allaboutdnt.com."
      }), /*#__PURE__*/_jsx("p", {
        id: "a9f245d0-8b78-43ce-af83-2946c4767036",
        children: "Declining to provide information. We need to collect personal information to provide certain services.\xA0 If you do not provide the information we identify as required or mandatory, we may not be able to provide those services."
      }), /*#__PURE__*/_jsx("p", {
        id: "2ce52fa1-32aa-45c6-a373-5de3862e5326",
        children: "Third-party platforms. If you choose to connect to the Service through your social media account or other third-party platform, you may be able to use your settings in your account with that platform to limit the information we receive from it. If you revoke our ability to access information from a third-party platform, that choice will not apply to information that we have already received from that third party."
      }), /*#__PURE__*/_jsx("p", {
        id: "7214ded3-0ba5-47a6-ba3e-054aec0179c7",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Other sites and services"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "f3a1fd73-3bd1-42f7-9c7b-3e66810f2fe0",
        children: "The Service may contain links to websites, mobile applications, and other online services operated by third parties.\xA0 In addition, our content may be integrated into web pages or other online services that are not associated with us.\xA0 These links and integrations are not an endorsement of, or representation that we are affiliated with, any third party.\xA0 We do not control websites, mobile applications, or online services operated by third parties, and we are not responsible for their actions. We encourage you to read the privacy policies of the other websites and mobile applications and online services you use."
      }), /*#__PURE__*/_jsx("p", {
        id: "51271cbc-ab7c-4237-8936-42f71dcdda81",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Security"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "a79f037a-f8a6-48d4-a56a-71170c5f8080",
        children: "We employ a number of technical, organizational and physical safeguards designed to protect the personal information we collect.\xA0 However, security risk is inherent in all internet and information technologies and we cannot guarantee the security of your personal information."
      }), /*#__PURE__*/_jsx("p", {
        id: "29b03dca-bec8-4703-884e-83d68e738644",
        children: /*#__PURE__*/_jsx("strong", {
          children: "International data transfer"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "aacd9f88-26cf-44ba-a030-b51c66d7794b",
        children: "We are headquartered in the United States and may use service providers that operate in other countries. Your personal information may be transferred to the United States or other locations where privacy laws may not be as protective as those in your state, province, or country."
      }), /*#__PURE__*/_jsx("p", {
        id: "8f687f30-5d8f-4e37-9ad9-c8815707870c",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Children"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "47ca3cea-16fd-4851-a729-306f1d22f710",
        children: "The Service is not intended for use by children under 13 years of age. If we learn that we have collected personal information through the Service from a child under 13 without the consent of the child\u2019s parent or guardian as required by law, we will delete it."
      }), /*#__PURE__*/_jsx("p", {
        id: "92825b22-93f1-49af-8f5e-a92549b37398",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Changes to this Privacy Policy"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "e2fec34b-a2d8-4dec-9a21-e068c34d070e",
        children: "We reserve the right to modify this Privacy Policy at any time. If we make material changes to this Privacy Policy, we will notify you by updating the date of this Privacy Policy and posting it on the Service. If required by law we will also provide notification of changes in another way that we believe is reasonably likely to reach you, such as via email or another manner through the Service.\xA0 Any modifications to this Privacy Policy will be effective upon our posting the modified version (or as otherwise indicated at the time of posting). In all cases, your use of the Service after the effective date of any modified Privacy Policy indicates your acceptance of the modified Privacy Policy."
      }), /*#__PURE__*/_jsx("p", {
        id: "22ad5d87-7b21-4fce-9b8b-a61b637b7983",
        children: /*#__PURE__*/_jsx("strong", {
          children: "How to contact us"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "5e134fb8-7971-443f-8bbe-7f12ed719732",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Notice to European users"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "687f74e6-4e10-4b34-ad27-4d6aa96ab734",
        children: "Personal information. References to \u201Cpersonal information\u201D in this Privacy Policy are equivalent to \u201Cpersonal data\u201D governed by European data protection legislation."
      }), /*#__PURE__*/_jsx("p", {
        id: "a3330e49-40d2-475c-9df2-18c45222c97d",
        children: "Controller. Subkit Inc. is the controller of your personal information covered by this Privacy Policy for purposes of European data protection legislation."
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx("strong", {
          children: "EU/UK Representative.\xA0 "
        }), "Our data protection representative in the European Union/United Kingdom is Subkit - as of: Piccadilly Business Centre, Aldow Enterprise Park, Manchester, M12 6AE", /*#__PURE__*/_jsx("strong", {
          children: "Email"
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "c436dcf2-6f0a-4405-904b-d2aed6fb2538",
        children: "Legal bases for processing. We use your personal information only as permitted by law. Our legal bases for processing the personal information described in this Privacy Policy are described in the table below."
      }), /*#__PURE__*/_jsx("p", {
        id: "51dafca7-8753-4e24-89a1-faf7dd62971e",
        children: "Use for new purposes. We may use your personal information for reasons not described in this Privacy Policy where permitted by law and the reason is compatible with the purpose for which we collected it.\xA0 If we need to use your personal information for an unrelated purpose, we will notify you and explain the applicable legal basis."
      }), /*#__PURE__*/_jsx("p", {
        id: "d274134c-c4f5-40d3-8301-e8ddd24fa493",
        children: "Your rights. European data protection laws give you certain rights regarding your personal information.\xA0 If you are located in Europe, you may ask us to take the following actions in relation to your personal information that we hold:"
      }), /*#__PURE__*/_jsx("p", {
        id: "5f9a15f3-824a-49ff-8281-4968e713bf3b",
        children: "Cross-border data transfer. If we transfer your personal information from Europe to another country such that we are required to apply appropriate safeguards to your personal information under European data protection laws, we will do so.\xA0 Please contact us for further information about any such transfers or the specific safeguards applied."
      }), /*#__PURE__*/_jsx("p", {
        id: "2934f76c-4478-4d02-9075-02782f198e7a",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Your choices"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "8b41183b-f5f8-4518-a597-86854abda82d",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Changes"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "a1a1ec31-4878-4597-958b-8a85acd5f974",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Questions"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "4d3694f5-dab6-4f86-b149-e295a58e32e1",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Personal information we collect"
        })
      }), /*#__PURE__*/_jsxs("p", {
        id: "f7224606-0607-4c03-a359-e5107c0d5924",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Information you provide to us.\xA0 "
        }), "Personal information you may provide to us through the Service or otherwise includes:"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "89b95bb9-f871-4e56-8932-4c3b6d0c34eb",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Contact data"
          }), ", such as your first and last name, email address, billing and mailing addresses, professional title and company name, and phone number."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Demographic Information"
          }), ", such as your city, state, country of residence, postal code, and age."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Profile data"
          }), ",such as the username and password that you may set to establish an online account with us, date of birth, links to your profiles on social networks, interests, preferences, information about your participation in our surveys, and any other information that you add to your account profile."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Communications"
          }), " that we exchange with you, including when you contact us with questions or feedback, through the Service, social media, or otherwise."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Transactional data"
          }), ", such as information relating to or needed to complete your orders on or through the Service, including order numbers and transaction history."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Marketing data"
          }), ", such as your preferences for receiving our marketing communications and details about your engagement with them."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "User-generated content"
          }), ", such as questions, comments, messages, feedback, works of authorship, when you \u201Cfavorite\u201D content, and other content or information that you generate, transmit, or otherwise make available on the Service, as well as associated metadata. Metadata includes information on how, when, where, and by whom a piece of content was collected and how that content has been formatted or edited. Metadata also includes information that users can add or can have added to their content, such as keywords, geographical or location information, and other similar data."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Payment information"
          }), " needed to complete transactions, including payment card information or bank account number. Please note, however that Subkit processes payment card information through Stripe and Subkit does not directly collect or maintain payment card information from users. For more information, please review the Payment Processors section under the \u201CHow we share your personal information heading below."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Promotional information, "
          }), "including information you share when you enter a competition, promotion or complete a survey. Please note that if you participate in a sweepstakes, contest or giveaway through the Service, we may ask you for your Contact Data to notify you if you win or not, to verify your identity and/or to send you prizes. In some situations, we may need additional information as a part of the entry process, such as a prize selection choice. These sweepstakes and contests are voluntary. We recommend that you read the rules and other relevant information for each sweepstakes and contest that you enter."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Other data "
          }), "not specifically listed here, which we will use as described in this Privacy Policy or as otherwise disclosed at the time of collection."]
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "cfcc9cc0-5ef6-4361-8872-9dbd74aa2894",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Third-party sources. "
        }), "We may combine personal information we receive from you with personal information we obtain from other sources, such as:"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "21b7f0ea-26f9-4c20-9c6b-c5e9dc4619f1",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Public sources"
          }), ", such as public records, social media platforms, and other publicly available sources."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Data providers"
          }), ", such as information services and data licensors that provide demographic and other information."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Marketing partners"
          }), ",", /*#__PURE__*/_jsx("strong", {
            children: " "
          }), "such as joint marketing partners and event co-sponsors."]
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "3daa60d3-3de5-49f7-a792-41d05aecf117",
        children: "If you choose to login to the Service via a third-party platform or social media network, or otherwise connect your account on the third-party platform or network to your account through the Service, we may collect information from that platform or network. For example, this information may include your Facebook username, user ID, profile picture, cover photo, and networks to which you belong (e.g. school, workplace). You may also have the opportunity to provide us with additional information via the third-party platform or network, such as a list of your friends or connections and your email address."
      }), /*#__PURE__*/_jsxs("p", {
        id: "4068c817-bfd3-4baf-a5e9-f46e310eb0ad",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Automatic data collection.\xA0 "
        }), "We, our service providers, and our business partners may automatically log information about you, your computer or mobile device, and your interaction over time with the Service, our communications and other online services, such as:"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "c6ffd753-c201-4583-b1c9-8bcbf28fe228",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Device data"
          }), ",", /*#__PURE__*/_jsx("strong", {
            children: " "
          }), "such as your computer\u2019s or mobile device\u2019s operating system type and version, manufacturer and model, browser type, screen resolution, RAM and disk size, CPU usage, device type (e.g., phone, tablet), IP address, unique identifiers (including identifiers used for advertising purposes), language settings, mobile device carrier, radio/network information (e.g., Wi-Fi, LTE, 3G), and general location information such as city, state or geographic area."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Online activity data"
          }), ", such as pages or screens you viewed, how long you spent on a page or screen, the website you visited before browsing to the Service, navigation paths between pages or screens, information about your activity on a page or screen, access times and duration of access, and whether you have opened our marketing emails or clicked links within them."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Location data"
          }), " when you authorize the Service to access your device\u2019s location."]
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "8092609c-bccb-41b5-a8dc-49e46db792c2",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Cookies"
        }), ". Some of our automatic data collection is facilitated by cookies and similar technologies. For more information, see our Cookie Notice."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "8805ecd5-3652-4701-aeed-efa0a389a0bf",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Data about others. "
        }), "Users of the Service may have the opportunity to refer friends or other contacts to us and share their contact information with us. Please do not refer someone to us or share their contact information with us unless you have their permission to do so."]
      }), /*#__PURE__*/_jsx("p", {
        id: "18e1742e-0fed-4364-b519-3db2ddf0a2b3",
        children: /*#__PURE__*/_jsx("strong", {
          children: "How we use your personal information"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "1165fbf8-e6e0-46e9-8a91-8c283ea860ea",
        children: "We may use your personal information for the following purposes or as otherwise described at the time of collection:"
      }), /*#__PURE__*/_jsxs("p", {
        id: "53f0bb6c-217f-4ff3-82d8-3a20701f2a14",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Service delivery.\xA0 "
        }), "We may use your personal information to:"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "4044a646-fb39-43a6-aee8-ba664a8b2894",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsx("li", {
          children: "provide, operate and improve the Service and our business;"
        }), /*#__PURE__*/_jsx("li", {
          children: "establish and maintain your user profile on the Service;"
        }), /*#__PURE__*/_jsx("li", {
          children: "facilitate your invitations to friends who you want to invite to join the Service;"
        }), /*#__PURE__*/_jsx("li", {
          children: "enable security features of the Service, such as by sending you security codes via email or SMS, and remembering devices from which you have previously logged in;"
        }), /*#__PURE__*/_jsx("li", {
          children: "communicate with you about the Service, including by sending announcements, updates, security alerts, and support and administrative messages;"
        }), /*#__PURE__*/_jsx("li", {
          children: "understand your needs and interests, and personalize your experience with the Service and our communications; and"
        }), /*#__PURE__*/_jsx("li", {
          children: "provide support for the Service, and respond to your requests, questions and feedback."
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "58051c76-3c81-45ad-a8fd-ff609f3cb6ff",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Research and development.\xA0 "
        }), "We may use your personal information for research and development purposes, including to analyze and improve the Service and our business."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "0e76fab7-c56c-4e19-92cc-752d90615e16",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Marketing and advertising.\xA0 "
        }), "We, our service providers and our third-party advertising partners may collect and use your personal information for marketing and advertising purposes:"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "c27033ac-7918-4c28-87bb-789dbcc22f6a",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Direct marketing"
          }), ". We may send you Subkit-related or other direct marketing communications as permitted by law.\xA0", /*#__PURE__*/_jsx("strong", {
            children: " "
          }), "You may opt-out of our marketing communications as described in the Opt-out of marketing section below."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Interest-based advertising. "
          }), "We may engage third-party advertising companies and social media companies to display ads on our Service and other online services. These companies may use cookies and similar technologies to collect information about your interaction (including the data described in the automatic data collection section above) over time across the Service, our communications and other online services, and use that information to serve online ads that they think will interest you. This is called interest-based advertising. We may also share information about our users with these companies to facilitate interest-based advertising to those or similar users on other online platforms. You can learn more about your choices for limiting interest-based advertising in the Your choices section of our Cookie Notice."]
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "a844dc06-33bd-456c-8159-a5c1bf065829",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Compliance and protection.\xA0 "
        }), "We may use your personal information to:"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "7f9eb301-ddb6-4733-82d7-b8f1d9619f91",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsx("li", {
          children: "comply with applicable laws, lawful requests, and legal process, such as to respond to subpoenas or requests from government authorities;"
        }), /*#__PURE__*/_jsx("li", {
          children: "protect our, your or others\u2019 rights, privacy, safety or property (including by making and defending legal claims);"
        }), /*#__PURE__*/_jsx("li", {
          children: "audit our internal processes for compliance with legal and contractual requirements and internal policies;"
        }), /*#__PURE__*/_jsx("li", {
          children: "enforce the terms and conditions that govern the Service; and"
        }), /*#__PURE__*/_jsx("li", {
          children: "prevent, identify, investigate and deter fraudulent, harmful, unauthorized, unethical or illegal activity, including cyberattacks and identity theft."
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "aa443d01-d381-4a48-9a2a-b7e2b6b89d08",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "With your consent.\xA0 "
        }), "In some cases, we may specifically ask for your consent to collect, use or share your personal information, such as when required by law.", /*#__PURE__*/_jsx("strong", {})]
      }), /*#__PURE__*/_jsxs("p", {
        id: "201cc0d3-c5d0-4951-94b3-2c8051c3dabc",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "To create anonymous, aggregated or de-identified data.\xA0 "
        }), "We may create anonymous, aggregated or de-identified data from your personal information and other individuals whose personal information we collect.\xA0 We make personal information into anonymous, aggregated or de-identified data by removing information that makes the data identifiable to you.\xA0 We may use this anonymous, aggregated or de-identified data and share it with third parties for our lawful business purposes, including to analyze and improve the Service and promote our business. ", /*#__PURE__*/_jsx("strong", {})]
      }), /*#__PURE__*/_jsxs("p", {
        id: "17d14c8f-8a4e-47da-961a-21f1c8359c46",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Retention"
        }), /*#__PURE__*/_jsx("strong", {
          children: "."
        }), " We generally retain personal information to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements, to establish or defend legal claims, or for fraud prevention purposes.\xA0 To determine the appropriate retention period for personal information, we may consider factors such as the amount, nature, and sensitivity of the personal information, the potential risk of harm from unauthorized use or disclosure of your personal information, the purposes for which we process your personal information and whether we can achieve those purposes through other means, and the applicable legal requirements."]
      }), /*#__PURE__*/_jsx("p", {
        id: "1fa372e0-ae7e-4e25-9253-601c64196220",
        children: "When we no longer require the personal information we have collected about you, we may either delete it, anonymize it, or isolate it from further processing."
      }), /*#__PURE__*/_jsx("p", {
        id: "ea6fe3e8-43a4-4386-a7a0-b07a406eda1b",
        children: /*#__PURE__*/_jsx("strong", {
          children: "How we share your personal information"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "0ac64fa2-e574-41db-803d-4384b03f6bc4",
        children: "We may share your personal information with the following parties and as otherwise described in this Privacy Policy or at the time of collection."
      }), /*#__PURE__*/_jsxs("p", {
        id: "b01b3d57-01e3-48b5-8648-e7daebc4e369",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Affiliates.\xA0 "
        }), "Our corporate parent, subsidiaries, and affiliates, for purposes consistent with this Privacy Policy."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "6f2b117e-263d-4f68-b741-273afabd9ba4",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Service providers."
        }), "\xA0 Third parties", /*#__PURE__*/_jsx("strong", {
          children: " "
        }), "that provide services on our behalf or help us operate the Service or our business (such as hosting, information technology, customer support, email delivery, marketing, and website analytics)."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "4f18abcb-dd93-4a21-bfc5-f9cb6bb8460f",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Payment processors"
        }), ". Any payment card information you use to make a purchase on the Service is collected and processed directly by our payment processors, such as Stripe. Stripe may use your payment data in accordance with its privacy policy, ", /*#__PURE__*/_jsx("a", {
          href: "https://stripe.com/privacy",
          children: "https://stripe.com/privacy"
        }), "."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "c654701c-e8d1-40c9-bd06-096d309e516b",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Advertising partners.\xA0 "
        }), "Third-party advertising companies for the interest-based advertising purposes described above."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "6d2186e6-1846-4948-bcc9-82d05096dc7f",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Third parties designated by you."
        }), /*#__PURE__*/_jsx("strong", {
          children: " "
        }), "We may share your personal data with third parties where you have instructed us or provided your consent to do so. This includes businesses you interact with that operate on our platform. We will share personal information that is needed for these other businesses to provide the services that you have requested.", /*#__PURE__*/_jsx("strong", {
          children: " "
        }), "If you have questions about how a business shares your personal information, you should contact the business or visit their privacy policy."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "0515df6f-3a8e-4132-b862-1046aed8e2e3",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Business and marketing partners. "
        }), "Third parties", /*#__PURE__*/_jsx("strong", {
          children: " "
        }), "with whom we collaborate on joint activities, with whom we have entered into joint marketing relationships or other joint ventures, or who we think may offer you products or services that you may enjoy."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "c8e4658d-4edc-4668-ba46-b9bc684fb05e",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Third-party platforms and social media networks. "
        }), "If you have enabled features or functionality that connect the Service to a third-party platform or social media network (such as by providing your API key or similar access token for the Service to a third party, or otherwise linking your account with the Service to a third party\u2019s services), we may disclose the personal information that you authorized us to share. We do not control the third party\u2019s use of your personal information."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "5823f097-3537-41e7-8162-5b89b09dfefa",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Professional advisors."
        }), "\xA0 Professional advisors, such as lawyers, auditors, bankers and insurers, where necessary in the course of the professional services that they render to us."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "071fef41-afea-43ed-9294-dc4d14c79dd2",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Authorities and others. "
        }), "Law enforcement, government authorities, and private parties, as we believe in good faith to be necessary or appropriate for the compliance and protection purposes described above."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "0aead988-919f-4fbb-9578-a852e5259e96",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Business transferees."
        }), "\xA0 Acquirers and other relevant participants in business transactions (or negotiations and diligence for such transactions) involving a corporate divestiture, merger, consolidation, acquisition, reorganization, sale or other disposition of all or any portion of the business or assets of, or equity interests in, Subkit or our affiliates (including, in connection with a bankruptcy or similar proceedings)."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "ac1b8e21-afae-44c4-9ed7-70090f5c9bcb",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Other users and the public.\xA0 "
        }), "Your profile and other user-generated content (except for messages) may be visible to other users of the Service and the public. For example, other users of the Service or the public may have access to your information if you chose to make your profile or other personal information available to them through the Service, such as when you provide comments, reviews, survey responses, or share other content. \xA0 This information can be seen, collected and used by others, including being cached, copied, screen captured or stored elsewhere by others (e.g., search engines), and we are not responsible for any such use of information."]
      }), /*#__PURE__*/_jsx("p", {
        id: "f5fe2b11-58ee-4350-85b9-a1f5aa4c395b",
        children: "We make commercially reasonable efforts to verify that the parties with whom our mobile application shares personal information provide a level of protection of personal information consistent with the practices described in this Privacy Policy, except that all such parties described above other than service providers and affiliates may, to the extent permitted by law, use personal information as described in their own privacy policies."
      }), /*#__PURE__*/_jsx("p", {
        id: "4fc1d9b7-bcea-43a4-a922-ccb0ea55ded9",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Your choices"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "32756fe4-fbdb-415d-a08f-a7ce3a0c50df",
        children: "You have the following choices with respect to your personal information."
      }), /*#__PURE__*/_jsxs("p", {
        id: "16d7591b-d75c-4724-912a-df3e5b1ad77f",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Access or update your information. "
        }), "If you have registered for an account with us through the Service, you may review and update certain account information by logging into the account."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "e084cc0d-71d2-424e-b26e-087f37d9cfa7",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Opt-out of marketing communications.\xA0 "
        }), "You may opt-out of marketing-related emails by following the opt-out or unsubscribe instructions at the bottom of the email, or by contacting us.\xA0 Please note that if you choose to opt-out of marketing-related emails, you may continue to receive service-related and other non-marketing emails."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "05712707-c1ee-4f74-8f8f-dbffa10fb733",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Cookies."
        }), "\xA0For information about cookies employed by the Service and how to control them, see our Cookie Notice."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "c6d0e261-7a87-4d5b-bc82-f40afd11285d",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Mobile location data.\xA0"
        }), " You can disable our access to your device\u2019s precise geolocation in your mobile device settings."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "b960b17d-838b-438e-a5a6-bf1740a82805",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Advertising choices. "
        }), "\xA0 You can limit use of your information for interest-based advertising by"]
      }), /*#__PURE__*/_jsxs("ul", {
        id: "0330992e-d2c3-420d-bbce-9d1a133dc595",
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Browser settings. "
          }), "Blocking third-party cookies in your browser settings."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Privacy browsers/plug-ins."
          }), " By using privacy browsers or ad-blocking browser plug-ins that let you block tracking technologies."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Platform settings."
          }), " Google and Facebook offer opt-out features that let you opt-out of use of your information for interest-based advertising:", /*#__PURE__*/_jsxs("ul", {
            className: "list-disc my-3 mx-6",
            children: [/*#__PURE__*/_jsxs("li", {
              children: ["Google:", /*#__PURE__*/_jsx("a", {
                href: "https://adssettings.google.com/",
                children: "https://adssettings.google.com/"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: ["Facebook: ", /*#__PURE__*/_jsx("a", {
                href: "https://www.facebook.com/about/ads",
                children: "https://www.facebook.com/about/ads"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Ad industry tools."
          }), " Opting out of interest-based ads from companies participating in the following industry opt-out programs:", /*#__PURE__*/_jsxs("ul", {
            className: "list-disc my-3 mx-6",
            children: [/*#__PURE__*/_jsxs("li", {
              children: ["Network Advertising Initiative:", ' ', /*#__PURE__*/_jsx("a", {
                href: "http://www.networkadvertising.org/managing/opt_out.asp",
                children: "http://www.networkadvertising.org/managing/opt_out.asp"
              })]
            }), /*#__PURE__*/_jsx("li", {
              children: "Digital Advertising Alliance: optout.aboutads.info."
            }), /*#__PURE__*/_jsxs("li", {
              children: ["AppChoices mobile app, available at", ' ', /*#__PURE__*/_jsx("a", {
                href: "https://www.youradchoices.com/appchoices",
                children: "https://www.youradchoices.com/appchoices"
              }), ", which will allow you to opt-out of interest-based ads in mobile apps served by participating members of the Digital Advertising Alliance."]
            })]
          })]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Mobile settings. "
          }), "Using your mobile device settings to limit use of the advertising ID associated with your mobile device for interest-based advertising purposes."]
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "d0bf0f78-1190-466c-a278-ea833f92bd4c",
        children: "You will need to apply these opt-out settings on each device from which you wish to opt-out."
      }), /*#__PURE__*/_jsxs("p", {
        id: "a96c9ced-d768-4e35-8f61-792ef8a94a11",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Do Not Track.\xA0 "
        }), "Some Internet browsers may be configured to send \u201CDo Not Track\u201D signals to the online services that you visit.\xA0 We currently do not respond to \u201CDo Not Track\u201D or similar signals.\xA0 To find out more about \u201CDo Not Track,\u201D please visit", /*#__PURE__*/_jsx("a", {
          href: "http://www.allaboutdnt.com/",
          children: "http://www.allaboutdnt.com"
        }), "."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "6510f5c4-235d-4044-ba80-5dee6ceba0c2",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Declining to provide information. "
        }), "We need to collect personal information to provide certain services.\xA0 If you do not provide the information we identify as required or mandatory, we may not be able to provide those services."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "64d17baf-0904-449a-804c-e3b9062c82f4",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Third-party platforms. "
        }), "If you choose to connect to the Service through your social media account or other third-party platform, you may be able to use your settings in your account with that platform to limit the information we receive from it. If you revoke our ability to access information from a third-party platform, that choice will not apply to information that we have already received from that third party."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "b0387cec-422c-4de6-a13f-8d9a5b8068c9",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Delete your content or close your account."
        }), " You can choose to delete certain content through your account.\xA0 If you wish to request to close your account, please contact us."]
      }), /*#__PURE__*/_jsx("p", {
        id: "3c1813f0-3921-48e9-86ab-89aa6df4a810",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Other sites and services"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "fc876725-11a4-4219-8aa1-37a0dd1701be",
        children: "The Service may contain links to websites, mobile applications, and other online services operated by third parties.\xA0 In addition, our content may be integrated into web pages or other online services that are not associated with us.\xA0 These links and integrations are not an endorsement of, or representation that we are affiliated with, any third party.\xA0 We do not control websites, mobile applications or online services operated by third parties, and we are not responsible for their actions. We encourage you to read the privacy policies of the other websites and mobile applications and online services you use."
      }), /*#__PURE__*/_jsx("p", {
        id: "e1be0de4-bb50-4be1-9491-43da2d73a3dd",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Security"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "5d42f800-45e3-458c-a5e5-141e75287f4d",
        children: "We employ a number of technical, organizational and physical safeguards designed to protect the personal information we collect.\xA0 However, security risk is inherent in all internet and information technologies and we cannot guarantee the security of your personal information."
      }), /*#__PURE__*/_jsx("p", {
        id: "74e1b6b6-abdb-4814-a68d-d25c32736ed2",
        children: /*#__PURE__*/_jsx("strong", {
          children: "International data transfer"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "8650c3e9-9e25-4f28-bdc9-5360581fb3b9",
        children: "We are headquartered in the United States and may use service providers that operate in other countries. Your personal information may be transferred to the United States or other locations where privacy laws may not be as protective as those in your state, province, or country."
      }), /*#__PURE__*/_jsx("p", {
        id: "ed663619-71b8-42f5-a084-c36f02784c43",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Children"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "948f0430-4427-4253-87b0-ef0ae48cabaa",
        children: "The Service is not intended for use by children under 13 years of age. If we learn that we have collected personal information through the Service from a child under 13 without the consent of the child\u2019s parent or guardian as required by law, we will delete it."
      }), /*#__PURE__*/_jsx("p", {
        id: "1d28924b-e0da-4929-b49f-5c42f4e532dd",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Changes to this Privacy Policy"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "87aa2c92-8867-41e9-a2c2-12b4dee750d3",
        children: "We reserve the right to modify this Privacy Policy at any time. If we make material changes to this Privacy Policy, we will notify you by updating the date of this Privacy Policy and posting it on the Service. If required by law we will also provide notification of changes in another way that we believe is reasonably likely to reach you, such as via email or another manner through the Service.\xA0 Any modifications to this Privacy Policy will be effective upon our posting the modified version (or as otherwise indicated at the time of posting). In all cases, your use of the Service after the effective date of any modified Privacy Policy indicates your acceptance of the modified Privacy Policy."
      }), /*#__PURE__*/_jsx("p", {
        id: "7daf056d-cbf8-48e3-b7fa-4448f530659e",
        children: /*#__PURE__*/_jsx("strong", {
          children: "How to contact us"
        })
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Email"
          }), ": hello@subkit.com", ' ']
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Mail"
          }), ": Subkit Inc."]
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "9a799d47-b162-46d7-97aa-ef7ffc0fe224",
        children: "1732 1st Avenue, #20997"
      }), /*#__PURE__*/_jsx("p", {
        id: "515971ca-e400-4804-a349-d2a2fad96a8e",
        children: "New York, New York 10128"
      }), /*#__PURE__*/_jsx("ul", {
        className: "list-disc my-3 mx-6",
        children: /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Phone"
          }), ": 347-673-0493"]
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "b69e8195-180b-4ae4-bfa5-fe1f7c13400d",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Notice to European users"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "aa30a2be-4f55-4d45-9c3d-edff5ac1c8e2",
        children: "The information provided in this \u201CNotice to European users\u201D section applies only to individuals in the United Kingdom, Switzerland, and the European Economic Area (hereafter collectively referred to as \u201CEurope\u201D)."
      }), /*#__PURE__*/_jsxs("p", {
        id: "4b41ecec-42af-4ab0-8dd6-92ce0264f73f",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Personal information. "
        }), "References to \u201Cpersonal information\u201D in this Privacy Policy are equivalent to \u201Cpersonal data\u201D governed by European data protection legislation."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "6ea85499-420f-4481-aa94-c9f19f611102",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Controller. "
        }), "Subkit Inc. is the controller of your personal information covered by this Privacy Policy for purposes of European data protection legislation."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "a226694b-248f-4543-b46e-6e53db622795",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "EU/UK Representative.\xA0 "
        }), "Our data protection representative in the European Union/United Kingdom is Subkit - as of: Piccadilly Business Centre, Aldow Enterprise Park, Manchester, M12 6AE", /*#__PURE__*/_jsx("strong", {
          children: "Email"
        }), ": hello@subkit.com", ' ']
      }), /*#__PURE__*/_jsxs("p", {
        id: "ed25fbad-f2d6-4351-ae6c-dac5c10343cf",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Legal bases for processing. "
        }), "We use your personal information only as permitted by law. Our legal bases for processing the personal information described in this Privacy Policy are described in the table below."]
      }), /*#__PURE__*/_jsxs("div", {
        id: "304abd61-1ed8-45c5-8301-2d7b5eefb8a1",
        className: "collection-content",
        children: [/*#__PURE__*/_jsx("h4", {
          className: "collection-title"
        }), /*#__PURE__*/_jsxs("table", {
          className: "table-auto border border-collapse",
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("th", {
                className: "border",
                children: "Processing purposeDetails regarding each processing purpose listed below are provided in the section above titled \u201CHow we use your personal information\u201D."
              }), /*#__PURE__*/_jsx("th", {
                className: "border",
                children: "Legal basis"
              })]
            })
          }), /*#__PURE__*/_jsxs("tbody", {
            children: [/*#__PURE__*/_jsxs("tr", {
              id: "509d2944-59ba-40fb-a6a3-d0f62398220d",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("strong", {
                  children: "Service delivery"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Processing-is-necessary-to-perform-the-contract-governing-our-provision-of-our-services-or-to-take-s-509d294459ba40fba6a3d0f62398220d",
                  children: "Processing is necessary to perform the contract governing our provision of our services or to take steps that you request prior to signing up for the services.\xA0 If we have not entered into a contract with you, we process your personal information based on our legitimate interest in providing the services you access and request."
                })
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              id: "793b086a-de01-4dc0-b557-8e88524c479b",
              children: [/*#__PURE__*/_jsxs("td", {
                className: "border",
                children: ["\u2022 ", /*#__PURE__*/_jsx("strong", {
                  children: "Research and development"
                }), "\u2022 ", /*#__PURE__*/_jsx("strong", {
                  children: "Marketing and advertising purposes"
                }), "\u2022", ' ', /*#__PURE__*/_jsx("strong", {
                  children: "Compliance and protection purposes"
                }), "\u2022", ' ', /*#__PURE__*/_jsx("strong", {
                  children: "Sharing your personal information "
                })]
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/These-activities-constitute-our-legitimate-interests-We-do-not-use-your-personal-information-for-t-793b086ade014dc0b5578e88524c479b",
                  children: "These activities constitute our legitimate interests.\xA0 We do not use your personal information for these activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law)."
                })
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              id: "03351eea-32bb-4fb1-b65c-6dc73ed37abc",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("strong", {
                  children: "To comply with applicable law"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Processing-is-necessary-to-comply-with-our-legal-obligations-03351eea32bb4fb1b65c6dc73ed37abc",
                  children: "Processing is necessary to comply with our legal obligations."
                })
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              id: "b7bb4b3f-c6c1-4243-a57e-6f3df3256bb5",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("strong", {
                  children: "With your consent"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Processing-is-based-on-your-consent-Where-we-rely-on-your-consent-you-have-the-right-to-withdraw-i-b7bb4b3fc6c14243a57e6f3df3256bb5",
                  children: "Processing is based on your consent.\xA0 Where we rely on your consent you have the right to withdraw it any time in the manner indicated when you consent or in the services."
                })
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "5db19817-42bb-4aea-956b-f7c2fba06365",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Use for new purposes. "
        }), "We may use your personal information for reasons not described in this Privacy Policy where permitted by law and the reason is compatible with the purpose for which we collected it.\xA0 If we need to use your personal information for an unrelated purpose, we will notify you and explain the applicable legal basis."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "311eda1c-40ff-4dad-b51c-f59862306293",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Retention. "
        }), "We retain personal information for as long as necessary to fulfil the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements, to establish or defend legal claims, or for Compliance and protection purposes."]
      }), /*#__PURE__*/_jsx("p", {
        id: "134bde44-9368-48e5-8596-625daf09ff53",
        children: "To determine the appropriate retention period for personal information, we consider the amount, nature, and sensitivity of the personal information, the potential risk of harm from unauthorized use or disclosure of your personal information, the purposes for which we process your personal information and whether we can achieve those purposes through other means, and the applicable legal requirements."
      }), /*#__PURE__*/_jsx("p", {
        id: "76089db4-1d62-4b81-afa9-3c743f3478ab",
        children: "When we no longer require the personal information we have collected about you, we will either delete or anonymize it or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible. If we anonymize your personal information (so that it can no longer be associated with you), we may use this information indefinitely without further notice to you."
      }), /*#__PURE__*/_jsxs("p", {
        id: "09ede178-6b00-4d53-93ff-358177efdce1",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Sensitive personal information."
        }), " We ask that you not provide us with any sensitive personal information (e.g., social security numbers, information related to racial or ethnic origin, political opinions, religion or other beliefs, health, biometrics or genetic characteristics, criminal background or trade union membership) on or through the services, or otherwise to us."]
      }), /*#__PURE__*/_jsx("p", {
        id: "7b3e777f-f343-47a8-a98a-7d27a29bae2c",
        children: "If you provide us with any sensitive personal information to us when you use the services, you must consent to our processing and use of such sensitive personal information in accordance with this Privacy Policy. If you do not consent to our processing and use of such sensitive personal information, you must not submit such sensitive personal information through our services."
      }), /*#__PURE__*/_jsxs("p", {
        id: "ecf47ccf-976c-4d1c-a584-ca6804fd3ddf",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Your rights. "
        }), "European data protection laws give you certain rights regarding your personal information.\xA0 If you are located in Europe, you may ask us to take the following actions in relation to your personal information that we hold:"]
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Access."
          }), " Provide you with information about our processing of your personal information and give you access to your personal information."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Correct."
          }), " Update or correct inaccuracies in your personal information."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Delete."
          }), " Delete your personal information."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Transfer."
          }), " Transfer a machine-readable copy of your personal information to you or a third party of your choice."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Restrict."
          }), " Restrict the processing of your personal information."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Object."
          }), " Object to our reliance on our legitimate interests as the basis of our processing of your personal information that impacts your rights."]
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "d1d8a98b-ce3c-4855-bd44-138cb6eab971",
        children: ["You may submit these requests by email to hello@subkit.com or our postal address provided above.\xA0 We may request specific information from you to help us confirm your identity and process your request.\xA0 Applicable law may require or permit us to decline your request.\xA0 If we decline your request, we will tell you why, subject to legal restrictions.\xA0 If you would like to submit a complaint about our use of your personal information or our response to your requests regarding your personal information, you may contact us or submit a complaint to the data protection regulator in your jurisdiction.\xA0 You can find your data protection regulator ", /*#__PURE__*/_jsx("a", {
          href: "https://edpb.europa.eu/about-edpb/board/members_en",
          children: "here"
        }), "."]
      }), /*#__PURE__*/_jsxs("p", {
        id: "8a30281a-7160-4d67-9e56-a747c7900fe1",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Cross-border data transfer. "
        }), "If we transfer your personal information from Europe to another country such that we are required to apply appropriate safeguards to your personal information under European data protection laws, we will do so.\xA0 Please contact us for further information about any such transfers or the specific safeguards applied."]
      }), /*#__PURE__*/_jsx("p", {
        id: "c4e71a83-da64-4cd7-a72d-56e874edd6ab",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Cookie Notice"
        })
      }), /*#__PURE__*/_jsxs("p", {
        id: "95307bca-6b57-478b-878f-f9294af3bb7e",
        children: ["This Cookie Notice explains how Subkit Inc. (\u201C", /*#__PURE__*/_jsx("strong", {
          children: "Subkit"
        }), "\u201D, \u201C", /*#__PURE__*/_jsx("strong", {
          children: "we"
        }), "\u201D, \u201C", /*#__PURE__*/_jsx("strong", {
          children: "us"
        }), "\u201D or \u201C", /*#__PURE__*/_jsx("strong", {
          children: "our"
        }), "\u201D) uses cookies and similar technologies in connection with"]
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("a", {
            href: "http://www.subkit.com/",
            children: "www.subkit.com"
          }), " and any other website that we own or control and which posts or links to this Cookie Notice (collectively, the \u201C", /*#__PURE__*/_jsx("strong", {
            children: "Sites"
          }), "\u201D); and"]
        }), /*#__PURE__*/_jsxs("li", {
          children: ["our mobile app (\u201C", /*#__PURE__*/_jsx("strong", {
            children: "App"
          }), "\u201D)."]
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "c54ada4c-4b63-4e4d-b44d-5927a830ea87",
        children: /*#__PURE__*/_jsx("strong", {
          children: "What are cookies?"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "71333929-d6b3-439d-b4c4-da26fb75b6ec",
        children: "Cookies are small data files that are placed on your computer or mobile device when you visit a website.\xA0 Cookies serve different purposes, like helping us understand how a site is being used, letting you navigate between pages efficiently, remembering your preferences, and generally improving your browsing experience."
      }), /*#__PURE__*/_jsx("p", {
        id: "95b236e4-4ee4-487c-a055-a9f2ce9cf736",
        children: "Our Sites may use both session cookies (which expire once you close your web browser) and persistent cookies (which stay on your computer or mobile device until you delete them)."
      }), /*#__PURE__*/_jsx("p", {
        id: "695ad7e8-0256-4aaf-8674-f716184e5da6",
        children: "We use two broad categories of cookies: (1) first party cookies, served directly by us to your computer or mobile device, which we use to recognize your computer or mobile device when it revisits our Sites; and (2) third-party cookies, which are served by service providers or business partners on our Sites, and can be used by these parties to recognize your computer or mobile device when it visits other websites. Third-party cookies can be used for a variety of purposes, including site analytics, advertising, and social media features."
      }), /*#__PURE__*/_jsx("p", {
        id: "9fa3e757-c561-4e20-a61d-04156bec468d",
        children: /*#__PURE__*/_jsx("strong", {
          children: "What types of cookies and similar tracking technologies does Subkit use on the Sites and App?"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "50d2655f-6e5f-4b3b-8e53-cd53f2ac63a3",
        children: "On the Sites, we use cookies and other tracking technologies in the following categories described in the table below."
      }), /*#__PURE__*/_jsxs("div", {
        id: "ac8e75ac-c4f9-4adf-9e4d-65ae82c2b5b6",
        className: "collection-content",
        children: [/*#__PURE__*/_jsx("h4", {
          className: "collection-title"
        }), /*#__PURE__*/_jsxs("table", {
          className: "table-auto border border-collapse",
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("th", {
                className: "border",
                children: "Type"
              }), /*#__PURE__*/_jsx("th", {
                className: "border",
                children: "Description"
              }), /*#__PURE__*/_jsx("th", {
                className: "border",
                children: "Who serves the cookies"
              }), /*#__PURE__*/_jsx("th", {
                className: "border",
                children: "How to control them"
              })]
            })
          }), /*#__PURE__*/_jsxs("tbody", {
            children: [/*#__PURE__*/_jsxs("tr", {
              id: "8c909ce9-1844-46bf-b96b-4e052f054161",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Advertising-8c909ce9184446bfb96b4e052f054161",
                  children: "Advertising"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: "These cookies are used by advertising companies to collect information about how you use our Sites and other websites over time.\xA0 These companies use this information to show you ads they believe will be relevant to you within our services and elsewhere, and to measure how the ads perform."
              }), /*#__PURE__*/_jsx("td", {
                className: "border"
              }), /*#__PURE__*/_jsx("td", {
                className: "border"
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              id: "8cd7df4f-04e0-4fc8-96a5-094d626d3e0f",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Analytics-8cd7df4f04e04fc896a5094d626d3e0f",
                  children: "Analytics"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: "These cookies help us understand how our services is performing and being used.\xA0 These cookies may work with web beacons included in emails we send to track which emails are opened and which links are clicked by recipients."
              }), /*#__PURE__*/_jsx("td", {
                className: "border"
              }), /*#__PURE__*/_jsx("td", {
                className: "border"
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              id: "2d5b1407-3c58-4873-99c1-ee818f456fa5",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Essential-2d5b14073c58487399c1ee818f456fa5",
                  children: "Essential"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: "These cookies are necessary to allow the technical operation of our services (e.g., they enable you to move around on a website and to use its features)."
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://policies.google.com/privacy",
                  children: "Google Tag Manager"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("span", {
                  className: "selected-value select-value-color-orange",
                  children: "See \u2018your choices\u2019 below."
                })
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              id: "43802a3a-c54a-4565-8720-f628a1b04bbb",
              children: [/*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.notion.so/Functionality-performance-43802a3ac54a45658720f628a1b04bbb",
                  children: "Functionality / performance"
                })
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: "Enhance the performance and functionality of our services."
              }), /*#__PURE__*/_jsx("td", {
                className: "border"
              }), /*#__PURE__*/_jsx("td", {
                className: "border",
                children: /*#__PURE__*/_jsx("span", {
                  className: "selected-value select-value-color-orange",
                  children: "See \u2018your choices\u2019 below."
                })
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("p", {
        id: "71984550-b38d-4082-a240-4f6e309c97b6",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Other technologies"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "c170aedb-6221-4851-8782-ed4cb36f4dd3",
        children: "In addition to cookies, our Sites may use other technologies, such as Flash technology to pixel tags to collect information automatically."
      }), /*#__PURE__*/_jsx("p", {
        id: "b373e529-b12d-4759-aaba-ca0e2dc5d569",
        children: "Browser Web Storage"
      }), /*#__PURE__*/_jsx("p", {
        id: "b8903fee-6761-42d3-be76-8eaf9c896bc3",
        children: "We may use browser web storage (including via HTML5), also known as locally stored objects (\u201CLSOs\u201D), for similar purposes as cookies. Browser web storage enables the storage of a larger amount of data than cookies. Your web browser may provide functionality to clear your browser web storage."
      }), /*#__PURE__*/_jsx("p", {
        id: "47edfe50-3a0e-42dd-bc63-e3232f905e26",
        children: "Flash Technology"
      }), /*#__PURE__*/_jsx("p", {
        id: "8b9dca22-13e0-4583-b2b4-bf22d761ccd7",
        children: "We may use Flash cookies (which are also known as Flash Local Shared Object (\u201CFlash LSOs\u201D)) on our Sites to collect and store information about your use of our Sites. Unlike other cookies, Flash cookies cannot be removed or rejected via your browser settings. If you do not want Flash LSOs stored on your computer or mobile device, you can adjust the settings of your Flash player to block Flash LSO storage using the tools contained in the Website Storage Settings Panel. You can also control Flash LSOs by going to the Global Storage Settings Panel and following the instructions. Please note that setting the Flash Player to restrict or limit acceptance of Flash LSOs may reduce or impede the functionality of some Flash applications, including, potentially, Flash applications used in connection with our Sites."
      }), /*#__PURE__*/_jsx("p", {
        id: "bdbcd247-1ffb-435e-b7eb-b7777bcf69c4",
        children: "Web Beacons"
      }), /*#__PURE__*/_jsx("p", {
        id: "e3f1dbbb-13a6-47fc-8181-aca7850fd8d0",
        children: "We may also use web beacons (which are also known as pixel tags and clear GIFs) on our Sites and in our HTML formatted emails to track the actions of users on our Sites and interactions with our emails. Unlike cookies, which are stored on the hard drive of your computer or mobile device by a website, pixel tags are embedded invisibly on webpages or within HTML formatted emails. Pixel tags are used to demonstrate that a webpage was accessed or that certain content was viewed, typically to measure the success of our marketing campaigns or engagement with our emails and to compile statistics about usage of the Sites, so that we can manage our content more effectively."
      }), /*#__PURE__*/_jsx("p", {
        id: "6d0d86fb-7cb4-4971-8f6a-d8e9a106bdeb",
        children: "Mobile Application Software Development Kits (SDKs)"
      }), /*#__PURE__*/_jsx("p", {
        id: "da355db9-6860-490b-8dd3-7c99a4e4d968",
        children: "We may use third-party software development kits (\u201CSDKs\u201D) in our mobile applications. A SDK is third-party computer code that may be used for a variety of purposes, including to provide us with analytics regarding the use of our mobile applications, to integrate with social media, add features or functionality to our app, or to facilitate online advertising. SDKs may enable third parties to collect information directly via our App."
      }), /*#__PURE__*/_jsx("p", {
        id: "6890291d-57c2-4df5-80f1-d6aa8a5aa5ec",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Your choices"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "99f90aef-c8fa-4db9-a39e-d5c36ee3a332",
        children: "Your options for controlling what information cookies and similar technologies collect about you include:"
      }), /*#__PURE__*/_jsxs("ul", {
        className: "list-disc my-3 mx-6",
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Blocking cookies in your browser."
          }), " Most browsers let you remove or reject cookies. To do this, follow the instructions in your browser settings. Many browsers accept cookies by default until you change your settings. Please note that if you set your browser to disable cookies, the Sites may not work properly. For more information about cookies, including how to see what cookies have been set on your device and how to manage and delete them, visit", ' ', /*#__PURE__*/_jsx("a", {
            href: "http://www.allaboutcookies.org/",
            children: "www.allaboutcookies.org"
          }), ". If you do not accept our cookies, you may experience some inconvenience in your use of our Sites. For example, we may not be able to recognize your computer or mobile device and you may need to log in every time you visit our Sites."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Third-party opt-out option. "
          }), "You can opt-out of interest-based advertising through some of the third parties listed in the chart above by using the corresponding third-party opt-out tool provided in the chart."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Industry association opt-outs"
          }), ". You may opt out of receiving interest-based advertising on websites through members of the Network Advertising Initiative by clicking", ' ', /*#__PURE__*/_jsx("a", {
            href: "http://www.networkadvertising.org/choices",
            children: "here"
          }), " or the Digital Advertising Alliance by clicking", ' ', /*#__PURE__*/_jsx("a", {
            href: "http://www.aboutads.info/choices",
            children: "here"
          }), ". You may opt out of receiving targeted advertising in mobile apps through participating members of the Digital Advertising Alliance by installing the AppChoices mobile app, available\xA0", /*#__PURE__*/_jsx("a", {
            href: "https://www.youradchoices.com/appchoices",
            children: "here"
          }), ", and selecting the user\u2019s choices. Please note that we also may work with companies that offer their own opt-out mechanisms and may not participate in the opt-out mechanisms linked above."]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Blocking advertising ID use in your mobile settings"
          }), ". Your mobile device settings may provide functionality to limit use of the advertising ID associated with your mobile device for interest-based advertising purposes."]
        })]
      }), /*#__PURE__*/_jsxs("p", {
        id: "f8285633-32b8-49db-9dbf-cb7cc6019e9a",
        children: ["For more information about cookies, including how to see what cookies have been set on your computer or mobile device and how to manage and delete them, visit", ' ', /*#__PURE__*/_jsx("a", {
          href: "http://www.allaboutcookies.org/",
          children: "www.allaboutcookies.org"
        }), ".\xA0 If you do not accept our cookies, you may experience some inconvenience in your use of our Sites. For example, we may not be able to recognize your computer or mobile device and you may need to log in every time you visit our Sites."]
      }), /*#__PURE__*/_jsx("p", {
        id: "22ee910a-e710-4a5a-bc25-4b73397c1f50",
        children: "If you choose to opt-out of targeted advertisements, you will still see advertisements online, but they may not be relevant to you. Even if you do choose to opt out, not all companies that serve online behavioral advertising are included in this list, and so you may still receive some cookies and tailored advertisements from companies that are not listed."
      }), /*#__PURE__*/_jsx("p", {
        id: "0bb07547-d127-41f2-9db7-b8ab76fcac12",
        children: "For more information about how we collect, use and share your information, see our Privacy Policy."
      }), /*#__PURE__*/_jsx("p", {
        id: "cf54d49f-dd53-4d6a-98b2-3be1a8a2ac8e",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Changes"
        })
      }), /*#__PURE__*/_jsx("p", {
        id: "171d9a0a-7d55-4f01-9407-54cf048dc5fd",
        children: "Information about the cookies we use may be updated from time to time, so please check back on a regular basis for any changes."
      }), /*#__PURE__*/_jsx("p", {
        id: "1b41819d-6adf-46ee-aa23-2933ade72fcb",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Questions"
        })
      }), /*#__PURE__*/_jsxs("p", {
        id: "3e0702d0-2acc-41bb-b822-47eeda0dfddd",
        children: ["If you have any questions about this Cookie Notice, please contact us by email at hello@subkit.com", ' ']
      }), /*#__PURE__*/_jsx("p", {
        id: "13e6ab9f-4d06-4921-8f46-ba01a5e275e1",
        children: "Last modified April 1st 2021"
      }), /*#__PURE__*/_jsx("p", {
        id: "91b4bade-5e5c-4992-adcc-7fac23cb621a"
      })]
    })
  });
};
export default PrivacyPage;